// extracted by mini-css-extract-plugin
module.exports = {"count":"CharacterSheetTicker_count_8zAeS"};